<template>
    <dialog-lx 
        v-bind.sync="dialogData" 
        v-loading="dialogLoading"
        @saveClick="planModify">
        <!-- 团队赛 修改信息 -->
        <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="150px" class="demo-ruleForm">
            <el-form-item :label="$t('planLxDetail.LXMC')" prop="planName">
                <el-input v-model="ruleForm.planName" :maxlength="22" size="small"></el-input>
            </el-form-item>
            <el-form-item :label="$t('planLxDetail.LXSJ')" prop="paperName">
                <el-input v-model="ruleForm.paperName" disabled size="small"></el-input>
            </el-form-item>
            <el-form-item class="el-form-item-time" :label="$t('planLxDetail.KTSJ')" required>
                <el-col :span="11">
                    <el-form-item prop="beginTime">
                        <el-date-picker value-format="yyyy-MM-dd HH:mm:ss" size="small" v-model="ruleForm.beginTime"
                            :picker-options="pickerOptions" type="datetime" @change="() => { ruleForm.endTime = '' }"
                            placement="bottom-start"
                            style="width: 100%" :placeholder="$t('planLxDetail.XZKSRQSJ')">
                        </el-date-picker>
                    </el-form-item>
                </el-col>
                <el-col class="line" style="text-align: center" :span="2">-</el-col>
                <el-col :span="11">
                    <el-form-item prop="endTime">
                        <el-date-picker size="small" style="width: 100%" value-format="yyyy-MM-dd HH:mm:ss"
                            v-model="ruleForm.endTime" :picker-options="pickerOptions" type="datetime"
                            placement="bottom-start"
                            :placeholder="$t('planLxDetail.XZJSRQSJ')">
                        </el-date-picker>
                    </el-form-item>
                </el-col>
            </el-form-item>
            <el-form-item :label="$t('planLxDetail.DCSJ')" prop="perTime">
                <el-input v-model.number="ruleForm.perTime" maxlength="6" :placeholder="$t('planLxDetail.FZ')" size="small">
                </el-input>
            </el-form-item>
            <el-form-item :label="$t('planLxDetail.KFCJ')"  prop="scoreFlag" v-auth="[['teacher'], 'pro']">
                <el-radio-group v-model="ruleForm.scoreFlag">
                    <el-radio :label="1">{{ $t('planLxDetail.S') }}</el-radio>
                    <el-radio :label="0">{{ $t('planLxDetail.F') }}</el-radio>
                </el-radio-group>
            </el-form-item>
            <el-form-item class="el-form-item-time" label-width="0" v-auth="[['teacher'], 'pro']">
                <el-col :span="24">
                    <el-col :span="12">
                        <el-form-item :label="$t('planLxDetail.LXCS')" prop="rule">
                            <el-radio-group size="small" v-model="ruleForm.rule">
                                <el-radio :label="0">{{ $t('planLxDetail.DC') }}</el-radio>
                                <el-radio :label="1">{{ $t('planLxDetail.XH') }}</el-radio>
                            </el-radio-group>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item :label="$t('planLxDetail.CZCS')" prop="resetTimes" v-if="ruleForm.rule === 1">
                            <el-input size="small" maxlength="3" v-model="ruleForm.resetTimes"
                                :placeholder="$t('planLxDetail.QSRXSKCZCS')"></el-input>
                        </el-form-item>
                    </el-col>
                </el-col>
            </el-form-item>
            <!-- v-auth="[['teacher'], 'pro']" -->
            <!-- 电商专业8 +  团队赛0 显示-->
           <el-form-item :label="$t('planLxDetail.TDCYSL')"  prop="teamMemberCount"  v-if="isTeamMemberCount">
                <el-input
                    :placeholder="$t('planLxDetail.QSRSZ')"
                    v-model="ruleForm.teamMemberCount"
                    onkeyup="value=value.replace(/[^0-9]/g,'');if(value>99){value=99};if(String(value)==='0'){value=1}"
                    size="small" />
            </el-form-item>
            <!-- professionId == 1 审计的 时候显示 是否开启共享中心   v-if="isShenJi"-->
            <el-form-item :label="$t('createExercise.WJGX')" prop="isOpenFile" v-if="pattern_lx == 0">
                <el-radio-group v-model="ruleForm.isOpenFile">
                        <el-radio :label="1">{{$t('createExercise.KQ')}}</el-radio>
                        <el-radio :label="0">{{$t('createExercise.GB')}}</el-radio>
                    </el-radio-group>
                </el-form-item>
                <el-form-item :label="$t('createExercise.FZTM')" prop="isOpenPaperCopy">
                    <el-radio-group v-model="ruleForm.isOpenPaperCopy">
                        <el-radio :label="1">{{$t('createExercise.KQ')}}</el-radio>
                        <el-radio :label="0">{{$t('createExercise.GB')}}</el-radio>
                    </el-radio-group>
                </el-form-item>
            <el-form-item :label="$t('planLxDetail.DAMS')" prop="answerFlag" v-auth="[['teacher'], 'pro']">
                <el-radio-group 
                    size="small" 
                    :disabled="!ruleForm.scoreFlag" 
                    v-model="ruleForm.answerFlag">
                    <el-radio :label="1">{{ $t('planLxDetail.JJKF') }}</el-radio>
                    <el-radio :label="2">{{ $t('planLxDetail.DTKF') }}</el-radio>
                    <el-radio :label="0">{{ $t('planLxDetail.GB') }}</el-radio>
                </el-radio-group>
            </el-form-item>
        </el-form>
    </dialog-lx>
</template>
<script>
import minsCreateExercise from '../createExercise/mins'
import dialogLx from '@/components/dialog-lx'
import fetch from '@/api/fetch'
export default {
    name: 'dialog-plan',
    mixins: [minsCreateExercise],
    components: {
        dialogLx
    },
    created() {
        this.dialogData.titleText = this.$t('planLxDetail.XGLX')
    },
    watch: {
        'ruleForm.scoreFlag'(val) {
            if (!val) {
                this.ruleForm.answerFlag = 0
            }
        }
    },
    methods: {
        planModify() {
            this.$refs['ruleForm'].validate(valid => {
                if (valid) {
                    fetch.planUpdate(this.ruleForm).then(res => {
                        if (res.code == 0) {
                            this.dialogData.addLxDialog = false
                            this.$parent.getList()
                            this.$notify({ title: this.$t('planLxDetail.CZ'), message: this.$t('planLxDetail.CZCG'), type: 'success' });
                        } else {
                            this.$notify({ title: this.$t('planLxDetail.CZ'), message: res.msg || this.$t('planLxDetail.XGSB'), type: 'error' });
                        }
                    })
                }
            })
        }
    }
}
</script>
<style scoped lang="scss">
/deep/ .el-form {
    .el-input {
        border-radius: 2px;

        .el-input__inner {
            background: #F1F2F4;
        }
    }

    .el-form-item {
        margin-bottom: 16px;
    }

    .el-form-item-time {
        margin-bottom: 0;
    }
}
</style>